export default "__VITE_ASSET__0b78c29e__"